export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier les postes"])},
        "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])},
        "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
      },
      "en": {
        "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit line items"])},
        "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
        "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
      }
    }
  })
}
